export const emptyFunction = () => {
  // empty function
  // use this function to avoid eslint "no-empty-function" warning.
};
